export default __webpack_public_path__ + "static/media/selamat4.cc39c9eb.svg";